<template>
    <div>
        <div class="d-flex">
            <v-btn
                small
                class="ml-auto"
                color="primary"
                @click="showTips = !showTips">
                VIEW AVAILABLE FUNCTIONS
            </v-btn>
        </div>
        <v-alert
            :value="showTips"
            outlined
            color="primary"
            dark
            border="right"
            transition="scale-transition">

            <v-row>
                <v-row>
                    <v-simple-table :light="true" class="mb-5">
                        <template>
                            <thead>
                                <tr>
                                    <th><h5>Functions</h5></th>
                                    <th><h5>Usage & Documentation</h5></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(fn, index) in availableFunctions"
                                    :key="'tips-' + index">
                                    <td class="f-width">{{ fn.name }}</td>
                                    <td class="rm-p-m">
                                        <div class="pt-4 m-desc" v-if="fn.docblock!=false"><pre>{{ fn.docblock }}</pre></div>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-row>
            </v-row>
        </v-alert>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showTips: false,
            availableFunctions: []
        }
    },

    created() {
        this.$http
            .get('/api/fieldmappers/functions')
            .then(({ data }) => {
                this.availableFunctions = data;
            })
            .catch(err => {
                EventBus.$emit('show-error', err);
            })
    }
}
</script>